import React from 'react'

const Vision = () => {
  return (
   <>
   <div className='bg-[#F7F7F7] w-[full] h-[908px]'>
<div className='pt-10 pl-[80px] '>
    <div>
    <h1 className='font-bold text-[64px] text-[#D62102]'>OUR VISION</h1>
    <p>PASSIONIT envisions a world where low-cost advanced IT education becomes a catalyst for <br/>
        empowering the economically underserved, fostering a global community of skilled professionals who<br/>
         offer cost-effective solutions to international companies.</p>
    </div>
</div>
   </div>
   </>
  )
}

export default Vision